import { ShoppingBag, Info } from "lucide-react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { PageHeader } from "@/components/PageHeader";
import { Reveal } from "@/components/Reveal";
import { Button } from "@/components/ui/button";
import { MERCH, ASSETS, ORG } from "@/lib/constants";
import { useSEO } from "@/hooks/useSEO";

export default function Merch() {
  useSEO({
    title: "Team Merch & Gear | CT BLAZERS AAU Basketball Norwalk, CT",
    description:
      "Shop CT BLAZERS branded team gear — hoodies, tees, hats, shorts and more. Represent the Blazers. Online ordering coming soon.",
    keywords: "CT Blazers merch, CT Blazers gear, AAU basketball apparel Norwalk CT",
    path: "/merch",
  });

  return (
    <div className="bg-ink-900 min-h-screen">
      <Navbar />
      <PageHeader
        eyebrow="Team Store"
        title="CT Blazers"
        highlight="Merch"
        image={ASSETS.boysTeam}
        subtitle="Rep the BLAZERS. Branded team gear for players and families. Online checkout is coming soon."
      />

      <section className="py-14 sm:py-20 bg-ink-800">
        <div className="container-x">
          <div
            data-testid="merch-notice"
            className="mb-8 flex items-start gap-3 rounded-xl border border-blaze-blue/30 bg-blaze-blue/10 p-4 text-sm text-white/75"
          >
            <Info size={18} className="mt-0.5 shrink-0 text-blaze-blueLight" />
            <span>
              Preview catalog — products, images and prices shown are placeholders. Online ordering will open soon.
              Questions in the meantime? Email{" "}
              <a href={`mailto:${ORG.email}`} className="text-blaze-orange hover:underline break-all">
                {ORG.email}
              </a>
              .
            </span>
          </div>

          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {MERCH.map((p, i) => (
              <Reveal key={p.name} delay={(i % 3) * 0.06}>
                <div
                  data-testid={`merch-item-${i}`}
                  className="hover-lift group flex h-full flex-col overflow-hidden rounded-2xl border border-white/10 bg-ink-700 hover:border-blaze-orange/40"
                >
                  <div className="relative aspect-square overflow-hidden bg-gradient-to-br from-white to-neutral-200">
                    <img
                      src={p.image}
                      alt={p.name}
                      loading="lazy"
                      className="h-full w-full object-contain p-6 transition-transform duration-500 group-hover:scale-105"
                    />
                    <span className="absolute top-3 left-3 rounded-full bg-ink-900/85 px-3 py-1 text-[10px] font-bold uppercase tracking-wider text-blaze-orange">
                      Coming Soon
                    </span>
                  </div>
                  <div className="flex flex-1 flex-col p-5">
                    <div className="flex items-start justify-between gap-3">
                      <h3 className="font-heading text-2xl tracking-wide text-white leading-none">{p.name}</h3>
                      <span className="font-heading text-2xl tracking-wide text-blaze-orange leading-none">{p.price}</span>
                    </div>
                    <p className="mt-2 flex-1 text-sm text-white/60 leading-relaxed">{p.desc}</p>
                    <Button
                      disabled
                      data-testid={`merch-buy-${i}`}
                      className="mt-4 w-full rounded-full h-11 border border-white/10 bg-white/5 text-white/50 font-bold uppercase tracking-wide text-xs hover:bg-white/5 disabled:opacity-100 cursor-not-allowed"
                    >
                      <ShoppingBag size={15} className="mr-1.5" /> Checkout Coming Soon
                    </Button>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
